import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoEmail = props =>
  (
<CustomerContactInfoComp
  {...props}
  autoComplete="email"
  description="We will send the booking confirmation to your email address."
  errorMessages={{
    'field_is_required': 'The email field is required',
    'field_is_invalid': 'Your email is invalid',
  }}
  label="Email"
  name="email"
  type="email"
/>
  );

export default CustomerContactInfoEmail;
